import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="disable-form"
export default class extends Controller {
  disableSubmit(_event) {
    this.element
      .querySelectorAll("button[type=submit], input[type=submit]")
      .forEach((element) => {
        element.disabled = true;
      });
  }
}
